// Hour cells save on blur, so clicking Submit sends the last cell's save right before the submit.
// Submitting locks the sheet, so the submit waits for these saves first.
const pending = new Set();

export const trackHourSave = save => {
  pending.add(save);
  const done = () => pending.delete(save);
  save.then(done, done);
  return save;
};

/** Resolves once every save started so far has settled; true when all of them succeeded. */
export const waitForHourSaves = async () => {
  const results = await Promise.allSettled([...pending]);
  return results.every(result => result.status === 'fulfilled');
};
